<aff-header></aff-header>

<div *ngIf="!isHidden()">
  <!-- Back button -->
  <div
    [attr.data-qa-id]="'back-button'"
    class="text-align-left"
    *ngIf="
      ((backButton$ | async)?.returnUrl || (backButton$ | async)?.goToPreviousPage) &&
      ((loading$ | async) === null || (loading$ | async) === undefined)
    "
  >
    <a [routerLink]="[]" (click)="backButtonClick()" class="c-pointer no-decoration flex">
      <!-- TODO: Icon size change in library -->
      <lib-back-icon class="icon-theme icon-xxs"></lib-back-icon>
      <p class="small color-grey pl-xxs font-weight-regular">
        {{ (backButton$ | async)?.buttonText ? (backButton$ | async)?.buttonText : 'Back' }}
      </p>
    </a>
  </div>

  <!-- Basic modal -->
  <ng-template #basicModal>
    <p class="mb-sm font-weight-bold">{{ (modal$ | async)?.text1 }}</p>
    <p class="mb-sm">
      <span [innerHtml]="$safeNavigationMigration((modal$ | async)?.text2)"></span>
      <a href="{{ (modal$ | async)?.linkUrl }}">{{ (modal$ | async)?.linkText }}</a>
      {{ (modal$ | async)?.text3 }}
    </p>

    <lib-button
      *ngIf="(modal$ | async)?.buttonText"
      [attr.data-qa-id]="'basic-modal-close-button'"
      styleName="button--primary"
      buttonText="{{ (modal$ | async)?.buttonText }}"
      (click)="modalButtonClick()"
    ></lib-button>
  </ng-template>

  <ng-template #modalWithSpinnerRef>
    <div class="modal-spinner">
      <lib-spinner [imageUrl]="" [attr.data-qa-id]="'modal-spinner'">
        <h4>{{ (modal$ | async)?.text1 }}</h4>
      </lib-spinner>
    </div>
  </ng-template>

  <lib-modal *ngIf="modal$ | async as modal" [attr.data-qa-id]="'modal'" (closeModalEvent)="closeModal()">
    <ng-template #content>
      <ng-container *ngIf="modal?.isSpinnerModal; else basicModal">
        <div class="modal-spinner">
          <lib-spinner [imageUrl]="" [attr.data-qa-id]="'modal-spinner'">
            <h4>{{ (modal$ | async)?.text1 }}</h4>
            <p class="mb-sm color-grey">
              <span [innerHtml]="$safeNavigationMigration((modal$ | async)?.text2)"></span>
            </p>
          </lib-spinner>
        </div>
      </ng-container>

      <ng-template #basicModal>
        <p class="mb-sm font-weight-bold">{{ (modal$ | async)?.text1 }}</p>
        <p class="mb-sm">
          <span [innerHtml]="$safeNavigationMigration((modal$ | async)?.text2)"></span>
          <a href="{{ (modal$ | async)?.linkUrl }}">{{ (modal$ | async)?.linkText }}</a>
          {{ (modal$ | async)?.text3 }}
        </p>

        <div class="mt-sm mb-sm" *ngIf="modal?.errorDetails?.correlationId">
          <p class="color-grey xsmall mr-xs" [attr.data-qa-id]="'problem-reference'">
            <span class="font-weight-bold">Problem Reference:</span> {{ (modal$ | async)?.errorDetails?.correlationId }}
          </p>
          <p class="color-grey xsmall P-sm" [attr.data-qa-id]="'time'">
            <span class="font-weight-bold">Time:</span> {{ (modal$ | async)?.errorDetails?.timeStamp }}
          </p>
        </div>

        <lib-button
          *ngIf="(modal$ | async)?.buttonText"
          [attr.data-qa-id]="'basic-modal-close-button'"
          styleName="button--primary"
          buttonText="{{ (modal$ | async)?.buttonText }}"
          (click)="modalButtonClick()"
        ></lib-button>
      </ng-template>
    </ng-template>
  </lib-modal>
</div>
